import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import useCardView from '../../../hooks/useCardView';
import DynamicBanner from '../DynamicBanner/DynamicBanner';

const MiddleBanner = ({ index, mobile }) => {
	const { ListerMobileMiddleBannerEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const {
		banners: { Middle } = {},
		productCardView,
		isDealsPage,
	} = useSelector((state) => state);

	const { isGridView, isListView } = useCardView();

	if (!Middle || !Array.isArray(Middle) || Middle.length === 0) {
		return null;
	}

	if (isDealsPage) {
		const dealsIndexPositions = {
			list: [6, 10, 14, 18, 22, 26],
			grid: [8, 12, 16, 20, 24, 28],
		};

		const bannerIndex = dealsIndexPositions?.[
			mobile ? 'list' : productCardView
		].indexOf(index);

		if (bannerIndex === -1) {
			return null;
		}

		const currentBanner = Middle?.[bannerIndex];

		if (!currentBanner) {
			return null;
		}

		if (['composite', 'text'].indexOf(currentBanner.Type) > -1) {
			return <DynamicBanner {...currentBanner} />;
		}
	}

	const { ImageUrl, LinkUrl, AltText = '', Type } = Middle[0];

	const showBanner = (isListView && index === 4) || (isGridView && index === 6);

	if (!showBanner && !mobile) {
		return null;
	}

	let mobileBanner;

	if (ListerMobileMiddleBannerEnabled && mobile) {
		mobileBanner = Middle.find(
			(item) => ['composite', 'text'].indexOf(item.Type) > -1
		);

		if (mobileBanner) {
			return <DynamicBanner {...mobileBanner} />;
		}
	} else if (['composite', 'text'].indexOf(Type) > -1) {
		return <DynamicBanner {...Middle[0]} />;
	}

	if (!ImageUrl) {
		return null;
	}

	if (LinkUrl) {
		return (
			<a
				href={LinkUrl}
				className={classnames('my-2 rounded-lg w-full', {
					'mt-0': isGridView && !isDealsPage,
				})}
				data-testid="middle-banner-link">
				<img className="w-full rounded-lg" src={ImageUrl} alt={AltText} />
			</a>
		);
	}

	return (
		<div
			className={classnames('sm:mx-1 my-2 w-full', {
				'mt-0': isGridView,
			})}>
			<img className="w-full rounded-lg" src={ImageUrl} alt={AltText} />
		</div>
	);
};

export default MiddleBanner;
